/* eslint-disable */

var model

var video
var stream

var frame_canvas
var ctx_frame_canvas

var canvas
var ctx
var canvas_w
var ctx_w

var inervalN
var wrapper_div
var div_width
var div_height
var height
var width
var last_matched_ts = 0 // Для заморозки кнопки.

var load_ai_prom = new Promise((resolve, reject)=>{
	blazeface.load().then(_model=>{
		model = _model
		consoleEnabled ? console.log("model loaded", (Date.now())) : false
		return resolve(model)
	}).catch(err=>{
		return reject(err)
	})
})

//// DEBUG /////////////////////////////////////////////////////////////////////////////////////////
// console.log("DEBUGGG")
// window.log = function (obj){
// 	let xhr = new XMLHttpRequest()
// 	xhr.open("POST", "https://igoos.4md.eu:8380/log")

// 	xhr.setRequestHeader("Accept", "application/json")
// 	xhr.setRequestHeader("Content-Type", "application/json")

// 	xhr.onload = () => console.log(xhr.responseText)

// 	let data = JSON.stringify(obj)

// 	xhr.send(data)
// }
//// DEBUG /////////////////////////////////////////////////////////////////////////////////////////

// Условия для показа console.log()
var env = process.env.VUE_APP_ENV
var consoleEnabled = env === 'development' || env === 'staging'

// Чтобы уменьшить время ожидания начну грузить нейросеть сразу,
// Результат суну в промис, а в init_cam только проверю промис.

window.face = {}
// Объект содержащий все методы и эвенты скрипта.

window.face.events = new EventTarget()
// window.face.events.addEventListener('started', console.log)

window.face.cb = function (obj){
	// задать калбэк получающий результаты анализа каждого кадра.
	// Никита у себя должен переписать ее своей.
	// Будет вызывать эту функцию передавая ей:
	// {
	// 	face_count: face_count, - сколько лиц (1 гуд, 0 нет лица, >1 много лиц)
	// 	dot_in_ellipse: dot_in_ellipse, - ключевые точки лица попадают в эллипс (гуд)
	// 	box_is_ok: box_is_ok, - Бокс лица не слишком большой (лицо влазит в эллипс, гуд)
	// 	ctx: ctx - Карандаш от видимого canvas. Можно что-то дорисовать после отрисовки кадра.
	// }
	consoleEnabled ? console.log("Default face detection callback, please assign your own callback to window.face.cb", obj) : false
}

window.face.draw = {
	// Флаги отрисовки на кадре, заменить своим...
	ellipse: true,		// Эллипс для лица
	dots: true,			// точки глаз.ушей.тд
	rectangle: true,	// квадрат лица
	rect_coeff: 1,		// Коэффициент. Сколько длинных радиусов эллипса взять за нормальную высоту куба.
	btn_freeze_ms: 300	// Задержка показа кнопки в статусе active
}
// ------------------------------------------------------------------------------------------------------------------------

function on_resize(){
	width = stream.getTracks()[ 0 ].getSettings().width
	height = stream.getTracks()[ 0 ].getSettings().height

	// Берем последний размер дива
	div_width = wrapper_div.offsetWidth
	div_height = wrapper_div.offsetHeight
	// Подгоняем под него канвасы (оба)
	// window.log({ evt:"resize div:", w:div_width,  h:div_height })
	// window.log({ evt:"resize vid:", w:width,  h:height })

	canvas.setAttribute('width', div_width)
	canvas.setAttribute('height', div_height)
	canvas_w.setAttribute('width', div_width)
	canvas_w.setAttribute('height', div_height)
	consoleEnabled ? console.log("resize w,h", div_width, div_height) : false
}

// Эта функция вызывается при нажатии кнопки сфотографировать
window.send_photo = function (user_id, img){
	consoleEnabled ? console.log(">>send_photo()") : false
	// Странно, но это не отрабатывает при взятии фото
	// ВНИМАНИЕ, эта функция не используется.
	// src/store/modules/user => sendPhoto()
	// src/views/Scanner.vue => saveSelfie()

	// user_id - user id returned on '/api/v1/init'
	// img - dom element for photo demo (document.getElementById("my_avatar"))
	if (img !== undefined){
		img.src = document.getElementById("canvas_w").toDataURL()
	}
	return new Promise((resolve,reject)=>{
		document.getElementById("canvas_w").toBlob(blob=>{
			let formData = new FormData()
			formData.append(user_id, blob, user_id + ".png")

			doAJAX_promise("/api/v1/photo_upload", formData)
			.then(r=>{
				resolve(r)
			})
			.catch(err=>{
				reject(err)
			})

		}, "image/jpeg", 1) // png?
	})
}

window.stop_cam = function (){
	// Останавливает работу веб-камеры
	clearInterval(inervalN)
	stream.getTracks()[ 0 ].stop()
	window.removeEventListener('resize', on_resize)
	video.removeEventListener("loadeddata", loadeddata)
}

/*
<div>
    <video id="video" autoplay="autoplay" style="display: none;"></video>
    <canvas id="canvas_w" width="520" height="520" style="display: none;"></canvas>
    <div class="flex-column flex-center mb-7 mt-xs-12 no-overflow">
        <div id="canvas_container">
            <canvas id="canvas" width="520" height="520"></canvas>
    	</div>
	</div>
</div>
*/

window.init_cam = function (){
	/// window.log({ evt:"init " })
	consoleEnabled ? console.log("init_cam", (Date.now())) : false

	// key: dev_capt
	// frame_canvas = document.createElement('canvas').setAttribute("id", "frame_canvas")
	frame_canvas = document.getElementById("frame_canvas")
	ctx_frame_canvas = frame_canvas.getContext("2d")
	// Канвас не подключенный к HTML для хранения полного кадра
	// Размер ему задается в activate_camera() (key: dev_capt)
	//
	// понадобится let image = canvas.toDataURL('image/jpeg')
	// canvas.width = 1920;
	// canvas.height = 1080;

	// Добавим в глобальные переменные ключевые элементы.
	video = document.getElementById("video")
	canvas = document.getElementById("canvas")
	canvas_w = document.getElementById("canvas_w")
	// И рисовалки от канвас.
	ctx = canvas.getContext("2d")
	ctx_w = canvas_w.getContext("2d")

	wrapper_div = document.getElementById("canvas_container")
	div_width = wrapper_div.offsetWidth
	div_height = wrapper_div.offsetHeight

	consoleEnabled ? console.log("Wrapper div w,h", div_width, div_height) : false

	// Форсим обоим канвас размеры дива.
	canvas.setAttribute('width', div_width)
	canvas.setAttribute('height', div_height)
	canvas_w.setAttribute('width', div_width)
	canvas_w.setAttribute('height', div_height)

	// Подготовка
	// Запускаем параллельно загрузку модели нейросети
	// и активацию камеры (что-бы не терять время)
	Promise.all([
		load_ai_prom,
		activate_camera()
	]).then(() =>{
		consoleEnabled ? console.log("model loaded and cam active", (Date.now())) : false
		// задаем в качестве src для тега video наш поток с камеры.
		video.srcObject = stream
	})

	// Поток не мгновенно подгружается в тег video
	// потому дальнейшие действия делаем при срабатывании loadeddata
	video.addEventListener("loadeddata", loadeddata)

	video.addEventListener('abort', () => { // -pause
		consoleEnabled ? console.log("bam") : false
		event_fired = false
	})

	// Вешаем ресайз листнер
	window.addEventListener('resize', on_resize)
	window.addEventListener('orientationchange', on_resize)
	//on_resize()
}

async function loadeddata(){
	consoleEnabled ? console.log("video loadeddata", (Date.now())) : false
	// Просто запускаем 25 раз в секунду, генерируя кадры
	inervalN = setInterval(detect_faces, 16.67)
	on_resize()
}

var event_fired = false
async function detect_faces(){
	// Одиночный акт поиска лица на текущем кадре
	// prediction это объект с координатами ключевых точек
	// Вернее массив объектов, потому что позволяет несколько лиц
	let dot_in_ellipse = undefined
	let box_is_ok = undefined
	let face_count = undefined

	let x_start
	let y_start
	let cut_len

	if (width > height){
		// Видеопоток лежит. Высота - меньшая ось, будет стороной квадрата.
		x_start = (width - height) / 2 // отступ по горизонтали от края видео до начала квадрата.
		y_start = 0 // Потому что высота видео == сторона квадрата.
		cut_len = height
	} else {
		// Видеопоток стоит.
		x_start =	0 // Потому что ширина видео == сторона квадрата.
		y_start = (height - width) / 2 // отступ по Вертикали от края видео до начала квадрата.
		cut_len = width
	}

	ctx_w.scale(-1,1)
	ctx_w.drawImage(video, x_start, y_start, cut_len, cut_len, 0, 0, -div_width, div_width)
	// Рисуем во временный канвас, (по сути вырезаем)

	// key: dev_capt
	// Задаем размер для неподключенного к ДОМ канвас.
	// Который будет кадром для анализа ИИ
	frame_canvas.width = cut_len
	frame_canvas.height = cut_len

	// key: dev_capt
	ctx_frame_canvas.drawImage(video,  -x_start, -y_start)
	// Копируем кадр сюда для сохранения в макс качестве для анализа ИИ

	// todo где-то тут нужно сделать дополнительный инструмент, для получения максимально качественной картинки.
	// var max_res_img = video.status

	const prediction = await model.estimateFaces(canvas_w, false)
	// Опознаем

	//ctx.drawImage(canvas_w, 0, 0);
	ctx.drawImage(canvas_w, 0, 0)
	// Перересовываем в канавас

	// Даем эвент, что все началось
	if (!event_fired){
		event_fired = true
		window.face.events.dispatchEvent(new CustomEvent('started', { success: true }))
	}

	// Рисуем эллипс для лица
	var x = (div_width / 2) // x центра
	var y = (div_width / 2) // y центра
	var ry = (div_width / 2) - 30 // радиус_у
	var rx = ry / 1.5 // радиус_х
	if (window.face.draw.ellipse){
		let border = 2
		// ctx.strokeStyle = 'rgba(120,184,115,1)'
		// ctx.lineWidth = border
		// ctx.beginPath()
		// ctx.ellipse(x, y, rx, ry, 0, 0, 2 * Math.PI)
		// ctx.stroke()

		// // Анти эллипс. ДЛЯ БЛУРА
		// ctx.fillStyle = 'rgba(255,255,255,0.5)'
		// ctx.beginPath()
		// ctx.ellipse(x, y, rx, ry, 0, 0, 2 * Math.PI)
		// ctx.rect(div_width + border, 0 - border, -div_width - (2 * border), div_width + (2 * border))
		// ctx.fill()
		// ctx.stroke()

		ctx.beginPath()

			ctx.fillStyle = 'rgba(255,255,255,0.5)'
			ctx.strokeStyle = 'rgba(120,184,115,1)'


			ctx.ellipse(x, y, rx, ry, 0, 0, 2 * Math.PI)
			//ctx.rect(div_width + border, 0 - border, -div_width - (2 * border), div_width + (2 * border))

			ctx.moveTo(div_width, 0); //MOVE top right
			ctx.lineTo(div_width, 0); //4
			ctx.lineTo(0, 0); //3
			ctx.lineTo(0, div_width); //2
			ctx.lineTo(div_width, div_width); // 1

		ctx.fill()
		ctx.stroke()
	}

	// Для определения принадлежности точки к эллипсу.
	function dot_in_elipse(x,y){
		return (Math.pow(x,2) / Math.pow(rx,2)) + (Math.pow(y,2) / Math.pow(ry,2)) <= 1
	}

	// netsh interface portproxy set v4tov4 listenport=6466 listenaddress=192.168.88.138 connectport=6466 connectaddress=172.27.238.197

	if (prediction.length > 0){
		face_count = prediction.length
		// Берем первое лицо, нам не нужно 2
		let pred = prediction[ 0 ]

		// Фактически нам тут нужно проверить попадают ли точки лица в овал для лица
		// Но пока нанесем их на кадр для наглядности
		ctx.beginPath()
		ctx.lineWidth = "1"

		// Небольшой воркэраунд. У нас тут 2 точки представляют квадрат,
		// bottomRight и topLeft
		// а для ctx.rect нужна 1 точка и 2 длинны w и h
		let rect_w = pred.bottomRight[ 0 ] - pred.topLeft[ 0 ]
		let rect_h = pred.bottomRight[ 1 ] - pred.topLeft[ 1 ]

		if (rect_h < ry * window.face.draw.rect_coeff){
			box_is_ok = false
			ctx.strokeStyle = "red"
		} else {
			box_is_ok = true
			ctx.strokeStyle = "blue"
		}
		if (window.face.draw.rectangle){
			ctx.rect(
				pred.topLeft[ 0 ],
				pred.topLeft[ 1 ],
				rect_w,
				rect_h
			)
			ctx.stroke()
		}

		dot_in_ellipse = true
		// И рисуем ключевые точки
		pred.landmarks.forEach(landmark => {
			if (dot_in_elipse((landmark[ 0 ]) - x, (landmark[ 1 ]) - y)){
				ctx.fillStyle = "green"
			} else {
				ctx.fillStyle = "red"
				dot_in_ellipse = false
			}
			if (window.face.draw.dots){
				ctx.fillRect(landmark[ 0 ], landmark[ 1 ], 5, 5)
			}
		})

	} else {
		face_count = 0
	}

	// Делаем отдельный флаг для активации кнопки с функцией задержки
	// Если условия совпали, то флаг подмораживается на интервал миллисекунд.
	// Даже если условия исчезли.
	var fts = window.face.draw.btn_freeze_ms
	var button_active = (face_count > 0 && dot_in_ellipse && box_is_ok)
	if (button_active){
		last_matched_ts = (Date.now())
	} else {
		var now = (Date.now())
		if (last_matched_ts + fts > now){
			button_active = true
		}
	}

	if (window.face !== undefined && window.face.cb !== undefined){
		window.face.cb({
			face_count: face_count,
			dot_in_ellipse: dot_in_ellipse,
			box_is_ok: box_is_ok,
			button_active: button_active,
			ctx: ctx
		})
	}
}

// async function load_model(){
//	 // Подгрузит нейросеть и поместит в глобальную переменную
// 	model = await blazeface.load()
// 	return
// }

async function activate_camera(){
	consoleEnabled ? console.log("activate_camera start", (Date.now())) : false
	// Активирует камеру, получит размеры потока.
	// Запишет в глобальне переменные.
	stream = await navigator.mediaDevices
	.getUserMedia({
		video: {
			width: {
				min: 640,
				ideal: 1280,
				max: 2560,
			},
			height: {
				min: 480,
				ideal: 730,
				max: 1440
			},
			facingMode: {
				ideal: 'user'
			}
		},
		audio: false,
	})

	// Получим фактические размеры видеопотока.
	width = stream.getTracks()[ 0 ].getSettings().width
	height = stream.getTracks()[ 0 ].getSettings().height
	consoleEnabled ? console.log("stream dims:", "width:" + width, "height:" + height) : false

	// key: dev_capt
	// Задаем размер для неподключенного к ДОМ канвас.
	// Который будет кадром для анализа ИИ
	frame_canvas.width = width
	frame_canvas.height = height

	return {
		width: width,
		height: height,
		stream: stream
	}
}

function ajaxObject(){
	let request
	try { request = new XMLHttpRequest() }
	catch (e1){
		try { request = new ActiveXObject("Msxml2.XMLHTTP") }
		catch (e2){
			try { request = new ActiveXObject("Microsoft.XMLHTTP") }
			catch (e3){
				return false
	}	}	}
	return request
}

function doAJAX_promise(url, params){
	return new Promise((resolve, reject) => {
		let request = new ajaxObject()
		request.open("POST", url, true)
		request.onreadystatechange = function (){
			if (this.readyState == 4){
				if (this.status == 200){
					resolve(this.responseText)
				} else {
					reject({
						message: "Request code != 200",
						status: this.status
					})
				}
			}
		}
		request.send(params)
	})
}

// // Пример придикшона с 1 лицом
// pred_example = [
// 	{
// 		"topLeft": [
// 			996.1212158203125,
// 			32.42403793334961
// 		],
// 		"bottomRight": [
// 			1255.407958984375,
// 			178.2762451171875
// 		],
// 		"landmarks": [
// 			[
// 				1118.3684599399567,
// 				66.29611998796463
// 			],
// 			[
// 				1184.6077251434326,
// 				72.84691125154495
// 			],
// 			[
// 				1140.7051829248667,
// 				102.02321246266365
// 			],
// 			[
// 				1112.0970958471298,
// 				135.78893557190895
// 			],
// 			[
// 				1041.3207721710205,
// 				72.96689048409462
// 			],
// 			[
// 				1193.4616577625275,
// 				94.16121024638414
// 			]
// 		],
// 		"probability": [
// 			0.8676906824111938
// 		]
// 	}
// ]
